import { render, staticRenderFns } from "./organizationList.vue?vue&type=template&id=4ccc047e&scoped=true&"
import script from "./organizationList.vue?vue&type=script&lang=js&"
export * from "./organizationList.vue?vue&type=script&lang=js&"
import style0 from "./organizationList.vue?vue&type=style&index=0&id=4ccc047e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc047e",
  null
  
)

export default component.exports